(function () {
  function boot() {
    document.querySelectorAll("[data-athletes-cat]").forEach((root) => {
      if (root.__athletesInit) return;
      root.__athletesInit = true;

      const jsonEl = root.querySelector("[data-athletes-cat-json]");
      if (!jsonEl) return;

      let payload;
      try { payload = JSON.parse(jsonEl.textContent); }
      catch(e){ return; }

      const cats = payload.cats || {};
      const variants = payload.variants || {};
      const variantDetails = payload.variant_details || {};


      const productRoot = root.closest("product-rerender, .shopify-section") || document;
      const observedFormId = productRoot.getAttribute ? productRoot.getAttribute("observe-form") : null;
      const escapeAttribute = (value) => String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');

      const cardsWrap = root.querySelector("[data-athletes-cat-cards]");
      const iconEl = root.querySelector("[data-athletes-cat-icon]");
      const nameEl = root.querySelector("[data-athletes-cat-name]");
      const vltEl = root.querySelector("[data-athletes-cat-vlt]");
      const catNoEl = root.querySelector("[data-athletes-cat-number]");
      const descEl = root.querySelector("[data-athletes-cat-desc]");

      const clamp = (n,a,b) => Math.max(a, Math.min(b, n));

      function getVariantInput() {
        if (observedFormId) {
          const form = document.getElementById(observedFormId);
          const formInput = form ? form.querySelector('[name="id"]') : null;

          if (formInput && formInput.value) {
            return formInput;
          }

          const externalInput = document.querySelector(`[form="${escapeAttribute(observedFormId)}"][name="id"]`);
          if (externalInput && externalInput.value) {
            return externalInput;
          }
        }

        const scopedInput = productRoot.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
        if (scopedInput && scopedInput.value) {
          return scopedInput;
        }

        return null;
      }

      function getVariantId() {
        const input = getVariantInput();
        const inputValue = input && input.value ? String(input.value) : null;

        if (inputValue && Object.prototype.hasOwnProperty.call(variants, inputValue)) {
          return inputValue;
        }

        const urlVariant = new URLSearchParams(window.location.search).get("variant");
        if (urlVariant && Object.prototype.hasOwnProperty.call(variants, urlVariant)) {
          return String(urlVariant);
        }

        return Object.keys(variants).find((variantId) => {
          return variants[variantId] !== null && typeof variants[variantId] !== "undefined";
        }) || null;
      }

	function renderDetails(variantId, catNumber) {
	  const vd = variantDetails[String(variantId)] || {};
	  const base = cats[String(catNumber)] || {};
	  const data = {
	    cat: typeof vd.cat !== "undefined" ? vd.cat : (typeof base.cat !== "undefined" ? base.cat : catNumber),
	    name: vd.name || base.name || "",
	    vlt: vd.vlt || base.vlt || "",
	    desc: vd.desc || base.desc || "",
	    image: vd.image || base.image || base.icon || ""
	  };

	  iconEl.innerHTML = data.image
	  ? `<img class="athletes-cat__detail-img" src="${data.image}" alt="" loading="lazy">`
  : "";

  nameEl.textContent = data.name || "–";
  vltEl.textContent = data.vlt || "–";

  const cat = typeof data.cat !== "undefined" ? data.cat : catNumber;
  catNoEl.textContent = `CAT ${cat}`;

  const desc = (data.desc || "").trim();
  descEl.textContent = desc;
  descEl.classList.toggle("is-empty", !desc);
}


      function renderCards(activeCat) {
        if (!cardsWrap) return;

        const left = clamp(activeCat - 1, 0, 4);
        const right = clamp(activeCat + 1, 0, 4);

        let html = "";
        for (let c = 0; c <= 4; c++) {
          const d = cats[String(c)] || {};
          html += `
            <button class="athletes-cat__card" type="button" data-cat="${c}">
              <span class="athletes-cat__ring" aria-hidden="true">
                ${d.icon ? `<img class="athletes-cat__ring-icon" src="${d.icon}" alt="" loading="lazy">` : ""}
              </span>
              <span class="athletes-cat__card-cat">CAT ${c}</span>
              <span class="athletes-cat__card-name">${d.name || ""}</span>
            </button>
          `;
        }
        cardsWrap.innerHTML = html;

        const cards = cardsWrap.querySelectorAll(".athletes-cat__card");
        cards.forEach((btn) => {
          const cat = Number(btn.getAttribute("data-cat"));
          btn.classList.toggle("is-active", cat === activeCat);
          btn.classList.toggle("is-neighbor", cat === left || cat === right);
          btn.classList.toggle("is-dim", cat !== activeCat && cat !== left && cat !== right);
        });
      }

      function update() {
        const vid = getVariantId();
        if (!vid) return;

        const activeCat = variants[String(vid)];
        if (activeCat === null || typeof activeCat === "undefined") return;

        renderCards(Number(activeCat));
        renderDetails(vid, Number(activeCat));
      }

      update();

      // Impact/Dawn/All
      document.addEventListener("variant:change", update);
      document.addEventListener("variant:changed", update);

      const idInput = getVariantInput();
      if (idInput) idInput.addEventListener("change", update);

      // Ultra fallback: re-check shortly after load
      setTimeout(update, 80);
      setTimeout(update, 400);
      setTimeout(update, 900);
      setTimeout(update, 1800);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("variant:change", boot);
  document.addEventListener("variant:changed", boot);

  if (window.MutationObserver) {
    const observer = new MutationObserver(() => boot());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
